import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import { ArrowLeft, Mail } from "lucide-react";
import { authService } from "../services/auth.service";
import pmLogo from "../assets/login/Logo.png";
import bannerImage from "../assets/login/banner.png";
import styles from "./ForgotPasswordPage.module.css";

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<{ email?: string }>({});
  const navigate = useNavigate();

  const validateEmail = (email: string): string | undefined => {
    if (!email) {
      return "Vui lòng nhập email";
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      return "Email không hợp lệ";
    }
    return undefined;
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setEmail(value);
    if (errors.email) {
      setErrors({ ...errors, email: undefined });
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const emailError = validateEmail(email);
    if (emailError) {
      setErrors({ email: emailError });
      return;
    }

    setLoading(true);
    try {
      await authService.forgotPassword(email);
      message.success("Mã OTP đã được gửi đến email của bạn!");
      // Navigate đến trang OTP verification
      navigate(`/otp-verification?email=${encodeURIComponent(email)}`);
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Gửi email thất bại. Vui lòng thử lại.";
      setErrors({ email: errorMessage });
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      {/* Left Section - Banner */}
      <div className={styles.leftColumn}>
        <div className={styles.bannerWrapper}>
          <img
            src={bannerImage}
            alt="Nền tảng quản lý doanh nghiệp toàn diện"
            className={styles.bannerImage}
          />
        </div>
      </div>

      {/* Right Section - Forgot Form */}
      <div className={styles.rightColumn}>
        <div className={styles.rightCard}>
          <button
            type="button"
            onClick={() => navigate("/login")}
            className={styles.backButton}
          >
            <ArrowLeft size={18} />
            <span>Quay lại</span>
          </button>

          <div className={styles.formContainer}>
            <img src={pmLogo} alt="Logo" className={styles.logo} />

            <div className={styles.header}>
              <Mail size={48} className={styles.icon} />
              <h2 className={styles.title}>Quên mật khẩu</h2>
              <p className={styles.description}>
                Vui lòng nhập email để đặt lại mật khẩu
              </p>
            </div>

            <form className={styles.form} onSubmit={handleSubmit}>
              <div className={styles.inputGroup}>
                <label className={styles.label}>Email</label>
                <input
                  type="email"
                  className={`${styles.input} ${
                    errors.email ? styles.inputError : ""
                  }`}
                  placeholder="Nhập email của bạn"
                  value={email}
                  onChange={handleEmailChange}
                  autoComplete="email"
                  disabled={loading}
                  autoFocus
                />
                {errors.email && (
                  <div className={styles.validationErrorMessage}>
                    {errors.email}
                  </div>
                )}
              </div>

              <button
                type="submit"
                className={styles.submitButton}
                disabled={loading}
              >
                {loading ? "Đang gửi..." : "Gửi mã OTP"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
